import React from 'react';
import { Input, Button } from 'components';
import { connect } from 'react-redux';
import { AuthService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router';
import { Logo, BgLogin, WelcomeImage } from 'assets/img';
import { Link } from 'react-router-dom';
import { PasswordInactive } from 'assets/icons';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Login extends React.Component<Props> {

	state = {
		showPassword: false,
		form: {
			email: '',
			password: '',
			web: true,
		}
	}

	componentDidMount() {
		if (this.props.user) {
			this.props.history.replace('/');
		}

		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: '',
				onBack: null
			}
		});
	}

	submit = async (e: any) => {
		e.preventDefault();
		const res: any = await AuthService.login(this.state.form);
		await this.props.dispatch({
			type: 'SET_USER',
			payload: res.user
		});
		this.props.history.replace('/');
	}

	disabled = () => {
		return this.state.form.email == '' || this.state.form.password == '';
	}

	change = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		});
	}

	togglePassword = () => {
		this.setState({
			showPassword: !this.state.showPassword
		});
	}

	render() {
		return (
			<div id="login">
				<section className="welcome">
					<img src={WelcomeImage} alt="Welcome" />
				</section>
				<main>
					<form onSubmit={ this.submit }>
						<div className="container-logo">
							<img src={ Logo } alt="Logo" />
						</div>
						<div className="container-input">
							<h1 className="title">Iniciemos</h1>
							<p className="subtitle">Inicia sesión o crea una cuenta.</p>

							<label>Correo</label>
							<div className="input-group">
								<Input
									name="email"
									onChange={ this.change }
								/>
							</div>
							<label>Contraseña</label>
							<div className="input-group">
								<Input
									type={ this.state.showPassword ? 'text' : 'password' }
									name="password"
									onChange={ this.change }
								/>
								<div className="input-group-prepend">
									<img src={ PasswordInactive } alt="Ver/Ocultar contraseña" onClick={this.togglePassword} />
								</div>
							</div>
							<div className="recover">
								<Link to="/recover">Olvidé contraseña</Link>
							</div>
							<div className="mx-auto">
								<Button type="submit">INICIAR SESIÓN</Button>
							</div>
							<div className="register">
								<Button type="button" onClick={ () => this.props.history.push('/register/select-level') }>
									REGISTRARME
								</Button>
							</div>
						</div>
					</form>
				</main>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Login);